import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { GlobalSearchResults } from './sub-models/global-search-results.model';
import { sum } from 'lodash';

export const GLOBAL_SEARCH_SCHEMA = Object.freeze({
  INVOICES: GlobalSearchResults,
  ESTIMATES: GlobalSearchResults,
  CREDIT_MEMOS: GlobalSearchResults,
  PURCHASE_ORDERS: GlobalSearchResults,
  CLIENTS: GlobalSearchResults,
  PRODUCTS: GlobalSearchResults,
  EXPENSES: GlobalSearchResults,
  TRACKED_TIMES: GlobalSearchResults,
  APPOINTMENTS: GlobalSearchResults,
});
const RECORD = generateSchema(GLOBAL_SEARCH_SCHEMA);
const KEYS: any = generateKeys(GLOBAL_SEARCH_SCHEMA);

export class GlobalSearch extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.INVOICES,
        value: new GlobalSearchResults(this.invoices),
      },
      {
        key: KEYS.ESTIMATES,
        value: new GlobalSearchResults(this.estimates),
      },
      {
        key: KEYS.CREDIT_MEMOS,
        value: new GlobalSearchResults(this.creditMemos),
      },
      {
        key: KEYS.PURCHASE_ORDERS,
        value: new GlobalSearchResults(this.purchaseOrders),
      },
      {
        key: KEYS.CLIENTS,
        value: new GlobalSearchResults(this.clients),
      },
      {
        key: KEYS.PRODUCTS,
        value: new GlobalSearchResults(this.products),
      },
      {
        key: KEYS.EXPENSES,
        value: new GlobalSearchResults(this.expenses),
      },
      {
        key: KEYS.TRACKED_TIMES,
        value: new GlobalSearchResults(this.trackedTimes),
      },
      {
        key: KEYS.APPOINTMENTS,
        value: new GlobalSearchResults(this.appointments),
      },
    ]);

    return selfModel as GlobalSearch;
  }

  get invoices(): GlobalSearchResults {
    return this.get(KEYS.INVOICES);
  }

  get estimates(): GlobalSearchResults {
    return this.get(KEYS.ESTIMATES);
  }

  get creditMemos(): GlobalSearchResults {
    return this.get(KEYS.CREDIT_MEMOS);
  }

  get purchaseOrders(): GlobalSearchResults {
    return this.get(KEYS.PURCHASE_ORDERS);
  }

  get clients(): GlobalSearchResults {
    return this.get(KEYS.CLIENTS);
  }

  get products(): GlobalSearchResults {
    return this.get(KEYS.PRODUCTS);
  }

  get expenses(): GlobalSearchResults {
    return this.get(KEYS.EXPENSES);
  }

  get trackedTimes(): GlobalSearchResults {
    return this.get(KEYS.TRACKED_TIMES);
  }

  get appointments(): GlobalSearchResults {
    return this.get(KEYS.APPOINTMENTS);
  }

  hasAnyResults(): boolean {
    return this.totalNumberOfResults() > 0;
  }

  totalNumberOfResults(): number {
    return sum([
      this.invoices.totalMatches,
      this.estimates.totalMatches,
      this.creditMemos.totalMatches,
      this.purchaseOrders.totalMatches,
      this.clients.totalMatches,
      this.products.totalMatches,
      this.expenses.totalMatches,
      this.trackedTimes.totalMatches,
      this.appointments.totalMatches,
    ]);
  }
}
